import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Spinner from '../../../shared/spinner';
import { ButtonAlterar, ButtonInativar } from '../../../shared/buttons';
import IntegracaoService from '../../../services/integracaoService';
import ConfirmModal from '../../../shared/customAlertConfirm';
import ResponsivePagination from 'react-responsive-pagination';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import ScrollToTopButton from '../../../shared/scrollToTopButton';

const service = new IntegracaoService();

function IntegracaoComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [lista, setLista] = useState<any[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [idExclusao, setIdExclusao] = useState<any>(null);

  const pageSize = 20;
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const listarIntegracoes = useCallback(async () => {
    try {
      setLoading(true);

      const response = await service.listarTodasIntegracoesPaginado(
        currentPage,
        pageSize
      );

      setLista(response.data.content || []);
      setTotalPages(response.data.totalPages || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [currentPage, pageSize]);


  const handleDelete = async () => {
    if (idExclusao) {
      try {
        await service.excluir(idExclusao);
        listarIntegracoes();
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setIdExclusao(null);
      }
    }
  };

  useEffect(() => {
    listarIntegracoes();
  }, [listarIntegracoes]);

  return (
    <div className="position-relative m-md-3">
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
        <h5>Sistema &gt; Integrações</h5>
        <Button
          onClick={() => navigate('/sistema-integracoes/inclusao', { state: { id: null } })}
          id="App-button-cor-principal-escura"
        >
          + Nova Integração
        </Button>
      </div>

      {loading ? <Spinner loading={loading} /> : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col" id="App-header-table">Código</th>
                <th scope="col" id="App-header-table">Nome</th>
                <th scope="col" id="App-header-table">Tipo</th>
                <th scope="col" id="App-header-table">Integração</th>
                <th scope="col" id="App-header-table" style={{ width: '50px' }}>Alterar</th>
                <th scope="col" id="App-header-table" style={{ width: '50px' }}>Excluir</th>
              </tr>
            </thead>
            <tbody>
              {lista.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.nome}</td>
                  <td>{item.tipo}</td>
                  <td>{item.integracao}</td>
                  <td>
                    <Link to={`/sistema-integracoes/alteracao`} state={{ id: item.id }}>
                      <ButtonAlterar />
                    </Link>
                  </td>
                  <td>
                    <ButtonInativar onClick={() => { setIdExclusao(item.id); setConfirmOpen(true); }} />
                  </td>
                </tr>
              ))}
              {lista.length === 0 && <tr><td colSpan={7} className="text-center">Nenhum registro encontrado.</td></tr>}
            </tbody>
          </table>
          <ResponsivePagination
            current={currentPage}
            total={totalPages}
            onPageChange={setCurrentPage} />
          <ScrollToTopButton />

          {confirmOpen && (
            <ConfirmModal
              message={'Tem certeza que deseja excluir esta integração?'}
              onConfirm={handleDelete}
              onCancel={() => { setConfirmOpen(false); setIdExclusao(null) }}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default IntegracaoComponent;
